/**
 * Service dashboard placeholder for v1. Becomes real once the NextX MCP exposes
 * service items (or we agree to map them onto an existing entity).
 */
export function ServicePlaceholder() {
  return (
    <section className="mx-12 mb-10 rounded-3xl border border-dashed border-aqua/20 bg-midnight/60 p-10 text-center">
      <h2 className="text-2xl font-medium uppercase tracking-[0.3em] text-aqua/70">
        Service dashboard
      </h2>
      <p className="mt-3 text-aqua/50">
        Coming next. Pending the NextX service-item data source.
      </p>
    </section>
  );
}
